// Dependencies
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';

// Models
import { OrganizationModel } from '../../models/organization.model';
import { StudyModel } from '../../models/study.model';
import { SurveyModel } from '../../models/survey.model';

// Services
import { StudyRequestService } from '../../services/study-request.service';

@Injectable()
export class StudyContainerPageService {
    constructor(private studyRequestService: StudyRequestService) {}

    // Properties
    respondentRoleList: Object[] = [];
    revisionId: number = null;
    organizationIdParam: number = null;
    organizationList: OrganizationModel[] = [];
    organizationModel: OrganizationModel = null;
    studyModel: StudyModel = null;
    studySlugParam: string = null;
    surveyModel: SurveyModel = null;
    studyLanguage: string = null;

    // UI
    ui = {
        error: false,
        loaded: false
    };


    // ----------------------------------
    // Public Methods
    // ----------------------------------

    getProperty(propertyName: string, subPropertyName: string = null) {
        let property = this[propertyName];
        if (!property) {
            return null;
        }

        if (!subPropertyName) {
            return property;
        }

        return property.get(subPropertyName);
    }

    getStudyData(studySlug: string, organizationId: number = null) {
        const studyRequests = Observable.forkJoin([
            this.studyRequestService.getBySlug(studySlug, 'participants.organization,revisions,survey', this.studyLanguage),
            this.studyRequestService.getBySlug(studySlug, 'partner.organization', this.studyLanguage)
        ]);

        studyRequests.subscribe(results => {
            const studyResponseWithChildren = results[0];
            const studyResponseWithPartner = results[1];

            let organizations = studyResponseWithChildren.included
                .filter(includedItem => includedItem.type === 'participants')
                .map((participant) => {
                    let organization = studyResponseWithChildren.included.find((element) => element.type === 'organizations' && element.id == participant.relationships.organization.data.id);
                    // add any extra participant metadata onto the organization record
                    organization.attributes = Object.assign(
                        organization.attributes,
                        {participant_meta: participant.attributes.hasOwnProperty('metadata') ? participant.attributes.metadata : {}}
                    );
                    return organization
                });

            this.organizationList = _.sortBy(organizations, org => org.get('friendly_name') ? org.get('friendly_name') : org.get('name'));

            this.revisionId = _.maxBy(studyResponseWithChildren.included.filter(includedItem => includedItem.type === 'study_revisions'), 'attributes.created_at').id;
            this.studyModel = studyResponseWithChildren.data;
            this.surveyModel = studyResponseWithChildren.included.find(includedItem => includedItem.type === 'surveys');

            const studyPartnerOrgId = studyResponseWithPartner.included.find(includedItem => includedItem.type === 'study_partners').relationships.organization.data.id;
            this.organizationModel = studyResponseWithPartner.included.find(includedItem => includedItem.type === 'organizations' && includedItem.id === studyPartnerOrgId);

            // Compile respondent role array
            const respondentRoles = this.studyModel.get('respondent_roles');
            for (let key in respondentRoles) {
                this.respondentRoleList.push({
                    key,
                    value: respondentRoles[key]
                });
            }

            this.ui.loaded = true;
        },
        errorResponse => {
            this.ui.loaded = true;
            this.ui.error = true;
        });

        return studyRequests;
    }

    setProperty(propertyName, propertyValue) {
        if (!_.isUndefined(this[propertyName])) {
            this[propertyName] = propertyValue;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/study-container-page/study-container-page.service.ts